import { usePageTitle } from '@hooks/usePageTitle';
import { FooterLinks } from '@area/footerLinks';

export const FooterLinksPage = () => {
  usePageTitle('Подвальные ссылки');

  return <FooterLinks />;
};
